import { Component, ViewContainerRef } from '@angular/core';
import { Faq } from '../../models/faq/faq-model'
import { FaqCategory } from '../../models/faq/faq-category-model'
import { FaqService } from '../../services/faq/faq.service';
import { FaqCategoryService } from '../../services/faq/faq-category.service'
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-edit-faq',
    templateUrl: './edit-faq.component.html',
    styleUrls: ['./edit-faq.component.scss']
})
/** edit-faq component*/
export class EditFaqComponent {
  faqModel = new Faq();
  faqID : string;
  errorMessage: any;
  FaqList: FaqCategory[];
  /** edit-faq ctor */
  constructor(private readonly faqService: FaqService, private readonly activatedRoute: ActivatedRoute, private readonly faqcatService: FaqCategoryService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("faq").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.activatedRoute.params.subscribe((params: Params) => {
              this.faqID = params['id'];
            });
            this.toastr.setRootViewContainerRef(vcr);
            this.getFaq(this.faqID);
            this.getFaqCategories();

          }
          else {
            this.router.navigate(["/faqs"]);
          }
        }
        else {
          this.router.navigate(["/faqs"]);
        }
      }
    )
  }
  onSubmit() {
    this.faqService.updateFaq(this.faqModel).subscribe(result => {
      if (result) {
        this.toastr.success('FAQ has been Updated. ', 'Success');
        //setTimeout(() => {
        //  this.router.navigate(["/faqs"]);
        //}, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Success');
      }
    });
  }
  getFaq(faqid : string) {
    this.faqService.getFaq(faqid).subscribe(
      data => {
        this.faqModel = data
      }
    )
  }
  getFaqCategories() {
    this.faqcatService.getFaqCategories().subscribe(
      data => {
        this.FaqList = data
      }
    )
  } 
}



// WEBPACK FOOTER //
// ./src/app/faq-components/edit-faq/edit-faq.component.ts